/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { Button } from '@/components/UI/Button';
import { LucideIcon } from 'lucide-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
type SidebarItemProps = {
  icon: LucideIcon;
  label: string;
  isExpanded: boolean;
  onClick: () => void;
  isSelected?: boolean;
};

function SidebarItem({
  icon: Icon,
  label,
  isExpanded,
  onClick,
  isSelected = false,
}: SidebarItemProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={`w-full justify-start text-white hover:bg-primary/80 ${isExpanded ? '' : 'justify-center'} ${isSelected ? 'bg-primary text-black' : ''}`}
    >
      <Icon className={`h-5 w-5 ${isExpanded ? 'mr-2' : ''}`} />
      {isExpanded && <span>{label}</span>}
    </Button>
  );
}

export { SidebarItem, type SidebarItemProps };
